import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { BRAND, NAV_LINKS, buildWhatsAppLink } from "../lib/constants";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-[#050505]/85 backdrop-blur-xl border-b border-[#1f1f1f]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link
            to="/"
            data-testid="header-logo-link"
            className="flex items-center gap-2 group"
          >
            <span className="font-display text-2xl md:text-3xl uppercase tracking-tight text-white leading-none">
              ACE<span className="text-[#CCFF00]">.</span>
            </span>
            <span className="hidden sm:inline-block text-[10px] tracking-[0.25em] uppercase text-[#A3A3A3]">
              Sublimasi Nusantara
            </span>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                className={({ isActive }) =>
                  `px-4 py-2 text-sm font-bold uppercase tracking-wider transition-colors ${
                    isActive
                      ? "text-[#CCFF00]"
                      : "text-white hover:text-[#CCFF00]"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          {/* CTA */}
          <a
            href={buildWhatsAppLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="header-whatsapp-cta"
            className="hidden md:inline-flex items-center gap-2 bg-[#CCFF00] text-black font-bold uppercase tracking-wider text-sm px-5 py-3 hover:bg-[#AACC00] hover:translate-y-[-2px] shadow-[3px_3px_0_#FF3B30] hover:shadow-[5px_5px_0_#FF3B30] active:translate-y-[1px] active:shadow-none transition-all"
          >
            <MessageCircle className="w-4 h-4" />
            Chat Admin
          </a>

          {/* Mobile toggle */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((s) => !s)}
            className="lg:hidden p-2 text-white"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div
            data-testid="mobile-menu"
            className="lg:hidden border-t border-[#1f1f1f] py-4 flex flex-col gap-1"
          >
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                className={({ isActive }) =>
                  `px-2 py-3 text-sm font-bold uppercase tracking-wider ${
                    isActive ? "text-[#CCFF00]" : "text-white"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <a
              href={buildWhatsAppLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="mobile-whatsapp-cta"
              className="mt-2 bg-[#CCFF00] text-black font-bold uppercase tracking-wider text-sm px-5 py-3 inline-flex items-center justify-center gap-2 shadow-[3px_3px_0_#FF3B30]"
            >
              <MessageCircle className="w-4 h-4" />
              Chat Admin {BRAND.whatsappDisplay}
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
